// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"452":"681246f4","548":"f824a5e1","564":"a1fff505","652":"fa5648a9","750":"ebe2069a","822":"0b8fcfb4","826":"bf73ee1e","937":"3304b134"}[chunkId] + ".1780942303696.chunk.js";
};